/**
 * Cloudinary chart-image keys are always built using en-US tokens, regardless
 * of the viewer's locale. The chart itself is a data visualization with no
 * embedded language, so one image fits every locale, and storing one shared
 * asset avoids re-uploading per locale on every page load.
 *
 * Only callers that build the lookup KEY (getFileName, getFileNameServer)
 * should use this helper. The alt-text builders MUST keep the real viewer
 * locale so screen readers and search engines see translated alt text.
 */
export function normalizeLocaleForImage(_locale) {
  return 'en-US';
}
